import { apiEndPoints, apiMethods } from '../../../../../utils/apiConstants'
import customAxios from '../../../../../utils/customAxios'

export const addToCartThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.addToCart, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchGetCartDetailsThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getCartDetails, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const removeProductFromCartThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.deleteCartProducts, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const validateSponserIdThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.validateSponserId, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const applyVoucherThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.applyVoucher, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const removeVoucherThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.removeVoucher, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const addShippingAddressThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.addShippingAddress, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const getShippingAddressThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getShippingAddress(body))
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const getOrderSummaryThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.orderSummary)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const makePhonePayPaymentThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.validatePaymentMethods, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const updateCartQuantityThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.updateCartQuantity, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
